import axios, { AxiosResponse } from "axios";
import { FanDetailsFormInput } from "../utils/formData";
import { FanData } from "../utils/models";

let baseUrl = process.env.REACT_APP_API_URL;

export function searchFan(formdata:{fanDetails:FanDetailsFormInput}) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/search`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formdata.fanDetails
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });

        // resolve({response: {
        //     data: {
        //     fans: [
        //         sampleFan1,
        //         sampleFan2
        //     ]
        // }}});
    });
}

export function getFan(fan_model?:string) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: fan_model?`${baseUrl}/api/fan-data/${fan_model}`:`${baseUrl}/fan-data`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}


export function getAllFans() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
                console.log(response.data)
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}
export function getAllArchievedFans() {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/archieved`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
                console.log(response.data)
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}
export function restorefan(formData:any) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/restore`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function getFanByFk(path:string,idType:string,id:string) {
    return new Promise<{ response: any }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/find/${path}/${idType}/${id}`,
            method: "GET",
            headers: {
                Accept: "application/json"
            }
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                if(err.response.status === 404)
                    resolve({response: null})
                reject({error: err})
            });
        });
}

export function reparent(payload:any) {
    return new Promise<{ response: any }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/reparent`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: payload
          })
            .then((response) => {
                resolve({response: true})
            })
            .catch((err) => {
                if(err.response.status === 404)
                    resolve({response: null})
                reject({error: err})
            });
        });
}

export function createFanUploadModel(formData:FanData) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/create`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function updateFanUploadModel(formData:FanData) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/update`,
            method: "PUT",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}

export function removeFanUploadModel(formData:FanData) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/remove`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}
export function removeHardFanUploadModel(formData:FanData) {
    return new Promise<{ response: AxiosResponse }>((resolve, reject) =>
    {
        axios({
            url: `${baseUrl}/api/fandetails/removeHard`,
            method: "POST",
            headers: {
                Accept: "application/json"
            },
            data: formData
          })
            .then((response) => {
                resolve({response: response.data})
            })
            .catch((err) => {
                console.error(err)
                reject({error: err})
            });
        });
}